import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { RoomEditPresenter } from "./presenter";
import { useRoomEditQuery } from "../../model/repository/existing";

type Props = {
	hotelID: string;
	roomID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const RoomEditContainer = ({ hotelID, roomID, activeLangCode, navigator }: Props) => {
	const serverModel = useRoomEditQuery({ hotelID, roomID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.ROOM.TOP, { hotelID })} />;
	}

	return <RoomEditPresenter activeLangCode={activeLangCode} navigator={navigator} serverModel={serverModel} />;
};

RoomEditContainer.displayName = "RoomEditContainer";
